<template>
  <div>
    <!-- <breadcrumb :routerList="[{to:'/xietongguanli/newManagement',title:'协同管理'},{title:'协同问题详情'}]" /> -->
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div
                  class="h-pieceTitle2"
                  style="margin-bottom: 0.3rem;"
                >
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine weekplandetail35">
                    <el-form
                      :model="bh"
                      label-position="right"
                      ref="bh"
                      :inline="true"
                      class="demo-ruleForm h-formbLine h-formbLine1"
                    >
                      <el-form-item
                        label="关差类型"
                        class="h-elformWrap-2"
                      >
                        <el-input
                          :value="filterGapType(bh.gapType)"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="关差内容"
                        class="h-elformWrap-2"
                      >
                        <el-input
                          :value="bh.gapContent"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="经销商名称"
                        class="h-elformWrap-2"
                      >
                        <el-input
                          :value="bh.userName"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="关差状态"
                        class="h-elformWrap-2"
                      >
                        <el-input
                          :value="gapStatus(bh.state)"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="创建时间"
                        class="h-elformWrap-2"
                      >
                        <el-input
                          v-model="bh.createDate"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="提交关差时间"
                        class="h-elformWrap-2"
                      >
                        <el-input
                          v-model="bh.submitDate"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        label="关差附件"
                        class="h-elformWrap-2"
                      >
                        <a
                          v-for="(item,index) in bh.fileInfoList"
                          :key="index"
                          class="el-upload-list__item-name"
                          style="cursor: pointer;font-size: 16px;"
                          v-down="item.id"
                        >{{item.name}}</a>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bannerBox2"
            v-if="taskstatus==0"
          >
            <div class="h-row h-mrt1">
              <div class="h-rowIn">
                <div class="h-rowBox">
                  <div class="h-rowCon">
                    <div class="h-pieceIn2">
                      <div
                        class="h-pieceTitle2"
                        style="margin-bottom: 0.3rem;"
                      >
                        <h1>审核信息</h1>
                      </div>
                      <div class="h-pieceCon2 ">
                        <div
                          class="h-formLine weekplandetail11"
                          style="position: relative;"
                        >
                          <el-form :inline="true">
                            <el-form-item
                              label="审批意见"
                              class="h-elformWrap-2 newBox"
                              style="width: 100%!important;"
                            >
                              <el-input
                                v-model="msg"
                                placeholder="请输入"
                              ></el-input>
                            </el-form-item>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="h-txtCenter h-mrt60">
            <el-button
              class="h-btn h-bBtn h-bgblueQ2"
              @click="backL"
            >返回</el-button>
            <el-button
              class="h-btn h-bBtn h-bgred"
              @click="pass(1)"
              v-if="taskstatus==0"
            >驳回</el-button>
            <el-button
              class="h-btn h-bBtn h-bggreen"
              @click="pass(2)"
              v-if="taskstatus==0"
            >通过</el-button>
            <el-button
              size="small"
              class="h-btn  h-bgblueQ2"
              @click="genzongLiuch"
            >
              跟踪审批
            </el-button>
            <!--查看跟踪审批流组件： showhistory：打开流程框，instid：流程id-->
            <viewhistory
              :visible.sync="showhistory"
              v-if="showhistory"
              :id="instid"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ss from '../../../api/SystemService'

export default {
  data () {
    return {
      id: null,
      showhistory: false,
      //带线表单
      bh: {},
      msg: '',
      instid: null,
      taskstatus: 0,
      taskid: null
    }
  },
  created () {
    this.id = this.$route.query.ywid || ''
    this.taskstatus = this.$route.query.taskstatus || ''
    this.instid = this.$route.query.instid || ''
    this.taskid = this.$route.query.taskid || ''
  },
  mounted () {
    this.query();
  },

  methods: {
    // 过滤当前能力
    filterGapType (type) {
      if (type == 1) {
        return '销售收入能力'
      } else if (type == 2) {
        return '直面用户能力'
      } else if (type == 3) {
        return '品类均衡能力'
      } else if (type == 4) {
        return '专业化团队能力'
      } else if (type == 5) {
        return '分销商对阵能力'
      } else if (type == 6) {
        return '机会获取能力'
      } else {
        return ''
      }
    },
    gapStatus (state) {
      if (state == 0) {
        return '关差'
      } else if (state == 1) {
        return '关差中'
      } else if (state == 2) {
        return '关差驳回'
      } else if (state == 3) {
        return '已关差'
      } else {
        return ''
      }
    },
    genzongLiuch () {
      this.showhistory = true;
    },
    query () {
      ss.noticeBoard.getJxsGapById({
        id: this.id
      }).then(rd => {
        console.log(rd)
        this.bh = rd.msg
      });
    },

    pass (val) {
      if (!this.msg) {
        this.$msg.msge("请填写审批意见再提交！");
        return false;
      }
      let data = {
        msg: this.msg,
        yewuzhujian: this.id,
        optflag: val == 1 ? '驳回' : '通过',
        tongguoorbohui: val,
        taskid: this.taskid
      }
      ss.noticeBoard.getApprovalGap(data).then(rd => {
        this.$msg.msgs("操作成功");
        this.backL()
      })
    },
    backL () {
      this.$router.go(-1);
    },
  }
}
</script>
<style scoped lang="scss">
.y-container {
  width: 100%;

  .y_tabBar {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;

    .eveBar {
      padding: 0.1rem 0.1rem 0.1rem 0.1rem;
      width: 2rem;
      height: 0.73rem;
      border: 1px solid #d9dfe9;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0.16rem;
      position: relative;
      cursor: pointer;
      font-size: 0.18rem;
      color: #525252;

      &:last-child {
        margin-right: 0;
      }

      .imgrigt {
        margin-left: 0.08rem;
      }
    }

    .eveBarAc {
      background-color: #248bff;
      color: white;
    }

    .redCircle {
      width: 0.15rem;
      height: 0.15rem;
      background-color: #e64a19;
      position: absolute;
      top: -0.06rem;
      right: -0.06rem;
      border-radius: 50%;
    }
  }

  .containGrey {
    width: 100%;
    border: 1px solid #dedede;
    background-color: #f9f9f9;
    margin-top: 0.4rem;

    .containAll {
      padding: 0.3rem;
      max-height: 3.6rem;
      width: 100%;
      overflow-y: auto;
    }

    .dialogDiv {
      margin-bottom: 0.2rem;

      .timeTip {
        color: #999999;
        font-size: 0.14rem;
        width: 100%;
        text-align: center;
        margin-bottom: 0.18rem;
      }

      .firstTalk {
        display: flex;

        .leftname {
          font-size: 0.18rem;
          color: #2a2a2a;
        }

        .containTalk {
          font-size: 0.16rem;
          color: #5e5e5e;
          border: 1px solid #dedede;
          background-color: white;
          width: 7.1rem;
          border-radius: 5px;
          margin-left: 0.3rem;
          padding: 0.2rem;
          word-break: break-word;
        }

        .containTalk2 {
          background-color: #e8e7e7;
          margin-right: 0.3rem;
          word-break: break-word;
        }
      }

      .firstTalk2 {
        flex-direction: row-reverse;
      }
    }

    .replyBox {
      padding: 0.2rem;
      border-top: 1px solid #dedede;
      display: flex;
      background-color: white;

      .tips {
        font-size: 0.18rem;
        color: #0072ed;
        flex-shrink: 0;
        margin-right: 0.15rem;
      }

      .replyBar {
        position: relative;
        width: 100%;

        .relpyInput {
          width: 100%;
          height: 0.72rem;
          border: none;
          background-color: #ffffff;
          outline: none;
          padding: 0.08rem;
          padding-top: 0.04rem;
          resize: none;
        }

        .h-bgblueQ2 {
          background-color: #2785e7;
          color: white;
          position: absolute;
          bottom: 0;
          right: 0;
          height: 0.46rem;
          width: 1.1rem;
          padding: 0;
        }
      }
    }
  }
}

.loopClosed {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
}

.loopClosed .loop {
  width: 30%;
  margin-left: 3%;
}

.loopClosed .loop:first-child {
  margin: 0;
}

.loopClosed .loop .title {
  font-size: 0.18rem;
  color: #0e75e9;
  font-weight: bold;
  border-left: 0.05rem solid #0e75e9;
  margin-bottom: 0.3rem;
  padding-left: 10px;
}

.loopClosed .loop .boxs {
  width: 100%;
  padding: 60px;
  box-sizing: border-box;
  border: 1px solid #e4e4e4;
  color: #868686;
  font-size: 0.16rem;
  margin-bottom: 0.3rem;
  border-radius: 3px;
}

.shenglue {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.loopClosed .loop .buttons {
  width: 145px;
  height: 55px;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  color: #323232;
  font-size: 0.16rem;
  text-align: center;
  line-height: 55px;
  margin-left: 50%;
  transform: translateX(-72px);
  cursor: pointer;
}
</style>
<style>
.weekplandetail35 .h-formbLine .el-form-item__label {
  width: 31%;
  text-align: right;
}

.weekplandetail35 .h-formbLine .el-form-item__content {
  width: 69%;
}

.weekplandetail35 .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem;
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem;
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 9.7%;
}

.weekplandetail35 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 90.3%;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}
.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785e7;
  z-index: 2;
}
.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;
  .leaderbg {
    width: 100%;
    height: 100%;
  }
  .steps {
    position: absolute;
    z-index: 1;
  }
  .step1 {
    top: 0;
    left: 0;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #ffffff;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }
  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }
  .el-textarea__inner {
    height: 26px;
    overflow-y: auto;
    /* overflow-y: auto;兼容ie  */
  }
}
</style>
<style>
.bannerBox2 .el-form-item__content {
  width: 85%;
}
.bannerBox2 .el-input__inner {
  border: none;
  border-bottom: 1px solid #dcdfe6 !important;
}
</style>
